import React from 'react';
import CategoryForm from './form';
import {getOneCategoryV2, updateSubcategory} from '../../modules/Api';
import {notification} from 'antd';
import history from '../../modules/History';

class EditCategory extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false
        }
    }
    componentDidMount() {
        this.fetchStoreDetail();
    }
    fetchStoreDetail() {
        const category_id = this.props.match.params.id;
        getOneCategoryV2(category_id, data => {this.setState({data: data})});
    }
    submit(formData) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const category_id = this.props.match.params.id;
        updateSubcategory(category_id, formData, () => {
            notification.open({
                message: `دسته‌بندی ویرایش شد!`,
            });
            this.setState({submitted: false});
            history.item.push(`/categories`);
        })
    }
    render() {
        return (<div><CategoryForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default EditCategory;


// WEBPACK FOOTER //
// ./src/containers/Categories/edit.js